import RightDrawer from "../../../RightDrawer";
import React, {useEffect, useState} from "react";
import MobileItem from "../../../MobileItem";
import ThumbnailAndNotification from "../../../ThumbnailAndNotification";
import {blueColor, greyishBlue500, red500, sidebarColor} from "../../../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import {getTranslation} from "../../../../../../domain/helpers/translations";
import {Card, CardContent} from "@mui/material";
import WmsMobileLayout from "../../../../../../views/wms/wmsMobileLayout";
import CustomButton from "../../../../../CustomButton";
import PropTypes from "prop-types";
import RetailerProducts from "./components/RetailerProducts";
import {useHistory} from "react-router-dom";
import ToggleNavigation from "../../../Toggle/ToggleNavigation";
import Toggle from "../../../Toggle/Toggle";
import {WMSRoutes} from "../../../../../../utils/WMSRoutes";
import {WmsTaskStatus} from "../../../../../../utils/WMSTaskStatus";

MyPickingMission.propTypes = {
    task: PropTypes.object,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    missionIndex: PropTypes.number,
}

/**
 * @returns {JSX.Element}
 */
export default function MyPickingMission({task, open, handleClose, missionIndex}) {
    const [retailers, setRetailers] = useState()
    const [openBottomDrawer, setOpenBottomDrawer] = useState(false)
    const [selectedRetailerItems, setSelectedRetailerItems] = useState([])
    const [places, setPlaces] = useState([])
    const [filter, setFilter] = useState(0)
    const [selectedToggle, setSelectedToggle] = useState('all')

    const history = useHistory()

    const openDrawer = (groupedItems) => {
        setSelectedRetailerItems(groupedItems)
        setOpenBottomDrawer(true);
    }
    const handleCloseBottomDrawer = () => {
        setOpenBottomDrawer(false);
    }

    const handleSelectedToggle = (index, placeId) => {
        setSelectedToggle(index)
        setFilter(placeId)
    }

    const handleMissionStart = (task) => {
        history.push(`${WMSRoutes.PICKING}/`, {task: task.id})
        handleClose()
    }

    useEffect(() => {
        if(task) {
            let retailers = []
            task.wmsItems.map((item) => {
                const key = item.lineItem.retailer.id

                if (!retailers.some(retailers => retailers.id === key)) {
                    retailers.push(item.lineItem.retailer)
                }
            })
            setRetailers(retailers)
            setPlaces(task.uniqueWMSItemsPlaces)
        }
    }, [task]);

    if (!task) {
        return null
    }

    return(
        <RightDrawer
            open={open}
            handleClose={handleClose}
            headerCenterContent={(
                <b><FormattedMessage id={"wms.myPickingMission.missionTitle"}/> {task?.name ?? missionIndex}</b>
            )}
        >
            <WmsMobileLayout disableMargin>
                <WmsMobileLayout.Content>
                    <RetailerProducts
                        open={openBottomDrawer}
                        handleClose={() => handleCloseBottomDrawer()}
                        wmsItems={selectedRetailerItems}
                    />
                    <Card>
                        <CardContent
                            sx={{
                                backgroundColor: sidebarColor,
                                display: 'flex',
                                flexDirection: 'row',
                                flexShrink: 0,
                                overflow: 'scroll'
                            }}
                        >
                            <div style={{marginRight: '8px'}}>
                                <Toggle
                                    round
                                    noWrapText
                                    label={"All"}
                                    count={task.wmsItems.length}
                                    checked={selectedToggle === 'all'}
                                    onClick={() => {
                                        setSelectedToggle('all')
                                    }}
                                />
                            </div>
                            <ToggleNavigation
                                withoutBackground
                                withChildMargin
                                value={selectedToggle}
                                onChange={(value) => {
                                    handleSelectedToggle(value, places[value].id)
                                }}
                            >
                                {places && places.map((place, index) => {
                                    return (
                                        <Toggle
                                            round
                                            noWrapText
                                            key={index}
                                            label={"no-place" === place.id ? <FormattedMessage id={"wms.myPickingMission.toggle.noZone"}/> : place.name}
                                            count={place.itemCount}
                                            checked={selectedToggle === index}
                                        />
                                    )
                                })}
                            </ToggleNavigation>
                        </CardContent>
                    </Card>
                    {retailers && retailers.map((retailer, index) => {
                        let hasItemsWithPlace = selectedToggle === 'all';
                        let wmsItems = task.wmsItems.filter((item) => {
                                if (item.lineItem.retailer && item.lineItem.retailer.id === retailer.id) {
                                    return item
                                }

                                if (retailer.id === 'noRetailer' && !item.lineItem.retailer) {
                                    return item
                                }
                            }
                        )
                        wmsItems.map((item) => {
                            if (0 === item.places.length && "no-place" === filter) {
                                hasItemsWithPlace = true
                            }

                            item.places.map((place) => {
                                if (place.id === filter) {
                                    hasItemsWithPlace = true
                                }
                            })
                        })

                        if (!hasItemsWithPlace) {
                            return null
                        }

                        const count = wmsItems.length

                        return (
                            <Card
                                key={retailer.id}
                                sx={{
                                    boxShadow: 0,
                                    margin: 0,
                                    padding: 0,
                                }}
                            >
                                <CardContent
                                    sx={{
                                        padding: 0,
                                        margin: 0
                                    }}
                                    style={{padding: 0}}
                                >
                                    <div
                                        style={{
                                            color: blueColor,
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            padding: 0,
                                            margin: 0
                                        }}
                                        onClick={() => {openDrawer(wmsItems)}}
                                    >
                                        <MobileItem key={index}>
                                            <MobileItem.LeftSide title={retailer.name}>
                                                <ThumbnailAndNotification
                                                    link={getTranslation(retailer).logo?.contentUrl || ""}
                                                    alt={retailer.name}
                                                />
                                            </MobileItem.LeftSide>
                                            <MobileItem.RightSide>
                                                <div>
                                                    <span
                                                        style={{
                                                            fontWeight:400,
                                                            fontSize: '12px',
                                                            color: greyishBlue500
                                                    }}>
                                                        {count} <FormattedMessage id={"wms.myPickingMission.articles"}/>
                                                    </span>
                                                </div>
                                            </MobileItem.RightSide>
                                        </MobileItem>
                                    </div>
                                </CardContent>
                            </Card>
                        )
                    })}
                </WmsMobileLayout.Content>
                <WmsMobileLayout.Footer>
                    <CustomButton
                        fullWidth
                        variant={"contained"}
                        onClick={() => handleMissionStart(task)}
                    >
                        {/* Need onClick action to redirect to a picking route with the mission id */}
                        <FormattedMessage id={task.status === WmsTaskStatus.IN_PROGRESS ? "wms.myPickingMission.resumeMission" : "wms.myPickingMission.startMission"}/> {task?.name ?? missionIndex}
                    </CustomButton>
                </WmsMobileLayout.Footer>
            </WmsMobileLayout>
        </RightDrawer>
    )
}
